import {
    VisualModalComponent
} from "../../../../../../../components/visual/modal/VisualModalComponent";
import {OfferBlockedNoPermissionComponent} from "../OfferBlockedNoPermissionComponent";

export class OfferBlockedNoPermissionModalComponent extends VisualModalComponent {
    constructor() {
        super();
        this.modalStyle = "width: 420px; padding: 35px;";
        this.noTitle = true;
        this.autoResize = true;

        const component = new OfferBlockedNoPermissionComponent();
        component.onClose = () => this.close();
        this.modalTemplate = this.draw(component);
    }
}
